import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
    'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
    'Noto Color Emoji';
  }

  .mantine-Paper-root{
   box-shadow: none !important;
  }

  .mantine-Paper-root > div {
   background-color: #fafafa !important;
  }

  /* div:has(.mantine-Table-root){
    outline: 1px solid #d9d9d9 !important;
  } */

`;
